export const PROPERTY_TYPE_HOUSE = 'house';
export const PROPERTY_TYPE_FLAT = 'flat';
export const PROPERTY_TYPE_OFFICE = 'office';
export const PROPERTY_TYPES = [
    PROPERTY_TYPE_HOUSE,
    PROPERTY_TYPE_FLAT,
    PROPERTY_TYPE_OFFICE,
];
